<template>
  <div>
    <el-form label-width="90px">
        <el-form-item label="背景图片">
          <el-col :span="18">
            <el-input v-model="curSelData.bgImg" placeholder="请输入背景图片地址">
              <template slot="append"
                ><span
                  style="cursor: pointer"
                  @click="selImg('CosmeticTag', 'bgImg')"
                  >选择图片</span
                ></template
              >
            </el-input>
          </el-col>
          <el-col :span="18">
            <img height="100px" :src="curSelData.bgImg" alt="" class="imgClass" />
          </el-col>
        </el-form-item>
        <!-- <div style="margin-top: 10px">
           <el-card class="box-card" style="margin-top: 10px">
            <div v-if="curSelData.btnList && curSelData.btnList.length">
              <div v-for="(btnItem, btnIndex) in curSelData.btnList" :key="btnIndex" class="btn-item">
                <div class="btn-text">{{ btnItem.text }}</div>
                <el-radio-group v-model="btnItem.type" class="btn-radio-group">
                  <el-radio :label="true" class="btn-radio">显示</el-radio>
                  <el-radio :label="false" class="btn-radio">隐藏</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div v-else class="no-btn-tip">
              暂无配置按钮数据
            </div>
          </el-card>
        </div> -->
        <!---防伪营销编辑开始-->
        <div style="margin-top: 10px" v-if="curSelData.btnList && curSelData.btnList[2].type">
        <div class="pageTit">防伪营销编辑</div>
        <el-card v-for="(item,index) in curSelData.swipePicList" :key="item.url+index+'edit'" class="box-card" style="margin-top: 10px">
              <div slot="header" class="clearfix">
                <el-button style="float: right; padding: 3px 0" type="text" @click="delSwipeItem(index)">删除</el-button>
              </div>
              <el-row>
                <el-col :span="6">
                  <el-image :src="item.url" style="display: block;height: 74px;width: 148px;max-width: 90%">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline" />
                    </div>
                  </el-image>
                </el-col>
                <el-col :span="18">
                  <el-input v-model="item.url" placeholder="请输入图片地址">
                    <template slot="append"><span style="cursor: pointer" @click="selImg('swipe','swipePicList',index,curSelData.imgType)">选择图片</span></template>
                  </el-input>
                  <!-- <el-input v-model="item.link" placeholder="请输入内容" style="margin-top: 10px">
                    <template slot="append">选择链接</template>
                  </el-input> -->
                </el-col>
              </el-row>
              <!-- <el-row>
                <el-input v-model="item.pagePath" placeholder="小程序路径" style="margin-top: 10px">
                  <template slot="append">跳转页面</template>
                </el-input>
              </el-row> -->
            </el-card>
            <el-button style="margin:20px auto;width: 80%;display: block" @click="addSwipeItem">添加轮播图</el-button>
        <!---防伪上边自定义图片--->
           <el-form-item label="图片位置">
            <template>
              <template>
                <el-radio v-model="curSelData.align" label="left">居左</el-radio>
                <el-radio v-model="curSelData.align" label="center">居中</el-radio>
                <el-radio v-model="curSelData.align" label="right">居右</el-radio>
              </template>
            </template>
          </el-form-item>
          <el-card v-for="(item,index) in curSelData.picList" :key="item.url + index" class="box-card" style="margin-top: 10px">
            <div slot="header" class="clearfix">
              <el-button style="float: right; padding: 3px 0" type="text" @click="delPic(index)">删除</el-button>
            </div>
            <el-row>
              <el-col :span="6">
                <el-image :src="item.url" style="display: block;height: 74px;width: 148px;max-width: 90%">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" />
                  </div>
                </el-image>
              </el-col>
              <el-col :span="18">
                <el-input v-model="item.url" placeholder="请输入图片地址">
                  <template slot="append"><span style="cursor: pointer" @click="selImg('CosmeticTag','picList', index)">选择图片</span></template>
                </el-input>
              </el-col>
              <el-input v-model="item.width" placeholder="请输入图片宽度" style="margin-top: 10px">
                <template slot="append">图片宽度</template>
              </el-input>
            </el-row>
          </el-card>
          <el-button style="margin:20px auto;width: 80%;display: block" @click="addItem">添加图片</el-button>
          <!---防伪上边自定义视频--->
           <el-card v-for="(item,index) in curSelData.videoList" :key="item.url + index" class="box-card" style="margin-top: 10px">
            <div slot="header" class="clearfix">
              <el-button style="float: right; padding: 3px 0" type="text" @click="delVideo(index)">删除</el-button>
            </div>
            <el-row>
              <el-col>
                <el-input v-model="item.url" placeholder="请输入视频链接">
                  <template slot="append"><span style="cursor: pointer" @click="selVideo(index)">选择视频</span></template>
                </el-input>
              </el-col>
            </el-row>
          </el-card>
          <el-button style="margin:20px auto;width: 80%;display: block" @click="addVideItem">添加视频</el-button>
          <el-form>
          <el-form-item label="自动播放">
              <el-radio v-model="curSelData.autoplay" :label="true">是</el-radio>
              <el-radio v-model="curSelData.autoplay" :label="false">否</el-radio>
            </el-form-item>
          </el-form>


          <!--防伪编辑-->
          <div class="rBox">
            <el-form label-width="90px">
              <el-form-item label="防伪背景颜色" class="formsItem">
                <template>
                  <bs-color-picker v-model="curSelData.bgColor" style="float:left;" />
                  <el-button type="primary" class="btnClear" @click="clearColor('bgColor')">清除</el-button>
                </template>
              </el-form-item>
              <el-form-item label="按钮背景色" class="formsItem">
                <template>
                  <bs-color-picker v-model="curSelData.btnBgColor" style="float:left;" />
                  <el-button type="primary" class="btnClear" @click="clearColor('btnBgColor')">清除</el-button>
                </template>
              </el-form-item>
            
              <el-form-item label="防伪背景图片">
                  <el-input v-model="curSelData.boxBg" placeholder="请输入图片地址">
                    <template slot="append"><span style="cursor: pointer" @click="selImg('CosmeticTag','boxBg')">选择图片</span></template>
                  </el-input>
                <el-col :span="18">
                  <img :src="curSelData.boxBg" alt="" class="imgClass">
                </el-col>
              </el-form-item>
              <el-form-item label="上边距">
                <template>
                  <bs-slider v-model="curSelData.paddTop" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="下边距">
                <template>
                  <bs-slider v-model="curSelData.paddBottom" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="左边距">
                <template>
                  <bs-slider v-model="curSelData.paddLeft" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="右边距">
                <template>
                  <bs-slider v-model="curSelData.paddRight" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="标题文字大小">
                <template>
                  <bs-slider v-model="curSelData.titleSize" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="标题文字颜色" class="formsItem">
                <template>
                  <bs-color-picker v-model="curSelData.titleColor" style="float:left;" />
                  <el-button type="primary" class="btnClear" @click="clearColor('titleColor')">清除</el-button>
                </template>
              </el-form-item>
              <el-form-item label="副标题文字大小">
                <template>
                  <bs-slider v-model="curSelData.SubheadingSize" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="副标题文字颜色" class="formsItem">
                <template>
                  <bs-color-picker v-model="curSelData.SubheadingColor" style="float:left;" />
                  <el-button type="primary" class="btnClear" @click="clearColor('SubheadingColor')">清除</el-button>
                </template>
              </el-form-item>
              <el-form-item label="二维码大小">
                <template>
                  <bs-slider v-model="curSelData.scanSize" :min="50" :max="150" />
                </template>
              </el-form-item>
              <el-form-item label="二维码上边距">
                <template>
                  <bs-slider v-model="curSelData.scanTop" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="二维码下边距">
                <template>
                  <bs-slider v-model="curSelData.scanBottom" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="二维左边距">
                <template>
                  <bs-slider v-model="curSelData.scanLeft" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="二维码背景">
                    <el-input v-model="curSelData.scanBg" placeholder="请输入图片地址">
                    <template slot="append"><span style="cursor: pointer" @click="selImg('CosmeticTag','scanBg')">选择图片</span></template>
                  </el-input>
              </el-form-item>
              
            <el-form-item label="提示信息文字大小">
              <template>
                <bs-slider v-model="curSelData.myBoxFize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="提示信息文字颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.myBoxColor" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('myBoxColor')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="提示信息图片">
                    <el-input v-model="curSelData.myBoxTipImg" placeholder="请输入图片地址">
                    <template slot="append"><span style="cursor: pointer" @click="selImg('CosmeticTag','myBoxTipImg')">选择图片</span></template>
                  </el-input>
            </el-form-item>
            <el-form-item label="标识码标题大小">
              <template>
                <bs-slider v-model="curSelData.codeTitleFize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="标识码标题颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.codeTitleColor" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('codeTitleColor')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="标识码文字大小">
              <template>
                <bs-slider v-model="curSelData.codeContentFize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="标识码颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.codeContentColor" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('codeContentColor')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="签发信息文字大小">
              <template>
                <bs-slider v-model="curSelData.msgBox3Fize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="签发信息颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.msgBox3Color" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('msgBox3Color')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="查询信息文字大小">
              <template>
                <bs-slider v-model="curSelData.msgBox4Fize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="查询信息文字颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.msgBox4Color" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('msgBox4Color')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="时间地点文字大小">
              <template>
                <bs-slider v-model="curSelData.msgBox5Fize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="时间地点文字颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.msgBox5Color" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('msgBox5Color')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="查询次数文字大小">
              <template>
                <bs-slider v-model="curSelData.msgBox6Fize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="查询次数文字颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.msgBox6Color" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('msgBox6Color')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="扫码次数大小">
              <template>
                <bs-slider v-model="curSelData.msgBox7Fize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="扫码次数颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.msgBox7Color" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('msgBox7Color')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="排序图片">
                <template>
                  <el-radio v-model="curSelData.myboxWrapImg" :label="1">显示</el-radio>
                  <el-radio v-model="curSelData.myboxWrapImg" :label="2">不显示</el-radio>
                </template>
            </el-form-item>
            <el-form-item label="标识码">
                  <template>
                    <el-radio v-model="curSelData.showVerCode" :label="1">不显示</el-radio>
                    <el-radio v-model="curSelData.showVerCode" :label="2">显示</el-radio>
                  </template>
              </el-form-item>
              <el-form-item label="跳转控件">
                  <template>
                    <el-radio v-model="curSelData.jumpStyle" :label="1">不显示</el-radio>
                    <el-radio v-model="curSelData.jumpStyle" :label="2">风格一</el-radio>
                  </template>
              </el-form-item>
            </el-form>
          </div>

          <!---防伪下边自定义图片--->
           <el-form-item label="图片位置">
            <template>
              <template>
                <el-radio v-model="curSelData.align2" label="left">居左</el-radio>
                <el-radio v-model="curSelData.align2" label="center">居中</el-radio>
                <el-radio v-model="curSelData.align2" label="right">居右</el-radio>
              </template>
            </template>
          </el-form-item>
          <el-card v-for="(item,index) in curSelData.picList2" :key="item.url + index" class="box-card" style="margin-top: 10px">
            <div slot="header" class="clearfix">
              <el-button style="float: right; padding: 3px 0" type="text" @click="delPic2(index)">删除</el-button>
            </div>
            <el-row>
              <el-col :span="6">
                <el-image :src="item.url" style="display: block;height: 74px;width: 148px;max-width: 90%">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" />
                  </div>
                </el-image>
              </el-col>
              <el-col :span="18">
                <el-input v-model="item.url" placeholder="请输入图片地址">
                  <template slot="append"><span style="cursor: pointer" @click="selImg('CosmeticTag','picList2', index)">选择图片</span></template>
                </el-input>
              </el-col>
              <el-input v-model="item.width" placeholder="请输入图片宽度" style="margin-top: 10px">
                <template slot="append">图片宽度</template>
              </el-input>
            </el-row>
          </el-card>
          <el-button style="margin:20px auto;width: 80%;display: block" @click="addItem2">添加图片</el-button>

          <!---防伪下边自定义视频--->
           <el-card v-for="(item,index) in curSelData.videoList2" :key="item.url + index" class="box-card" style="margin-top: 10px">
            <div slot="header" class="clearfix">
              <el-button style="float: right; padding: 3px 0" type="text" @click="delVideo2(index)">删除</el-button>
            </div>
            <el-row>
              <el-col>
                <el-input v-model="item.url" placeholder="请输入视频链接">
                  <template slot="append"><span style="cursor: pointer" @click="selVideo2(index)">选择视频</span></template>
                </el-input>
              </el-col>
            </el-row>
          </el-card>
           <el-button style="margin:20px auto;width: 80%;display: block" @click="addVideItem2">添加视频</el-button>
          <el-form>
          <el-form-item label="自动播放">
              <el-radio v-model="curSelData.autoplay2" :label="true">是</el-radio>
              <el-radio v-model="curSelData.autoplay2" :label="false">否</el-radio>
            </el-form-item>
          </el-form>


          <!--商品组开始-->
            
          <div class="rBox">
            <el-form label-width="90px">
              <el-form-item label="图片高度">
                <template>
                  <bs-slider v-model="curSelData.spImgHeight" :min="0" :max="300" />
                </template>
              </el-form-item>
              <el-form-item label="标题">
                <el-input
                  v-model="curSelData.spTitle"
                  type="text"
                  placeholder="请输入标题">
                  <el-button slot="append" @click="clearTit">清除</el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="小标题">
                <el-input
                  v-model="curSelData.spSubTitle"
                  type="text"
                  placeholder="请输入小标题">
                  <el-button slot="append" @click="clearSubTit">清除</el-button>
                </el-input>
              </el-form-item>

              <el-form-item label="标题">
                <template>
                  <template>
                    <el-radio v-model="curSelData.spTitleVisible" :label="true">显示</el-radio>
                    <el-radio v-model="curSelData.spTitleVisible" :label="false">不显示</el-radio>
                  </template>
                </template>
              </el-form-item>

              <el-form-item label="小标题">
                <template>
                  <template>
                    <el-radio v-model="curSelData.spSubTitleVisible" :label="true">显示</el-radio>
                    <el-radio v-model="curSelData.spSubTitleVisible" :label="false">不显示</el-radio>
                  </template>
                </template>
              </el-form-item>

              <el-form-item label="列表样式">
                <template>
                  <template>
                    <el-radio v-model="curSelData.listStyle" :label="1">单列显示</el-radio>
                    <el-radio v-model="curSelData.listStyle" :label="2">双列显示</el-radio>
                    <!-- <el-radio v-model="curSelData.listStyle" :label="3">列表显示</el-radio> -->
                  </template>
                </template>
              </el-form-item>

              <el-form-item label="背景颜色" class="formsItem">
                <template>
                  <bs-color-picker v-model="curSelData.spBgColor" style="float:left;" />
                  <el-button type="primary" class="btnClear" @click="clearColor('spBgColor')">清除</el-button>
                </template>
              </el-form-item>

              <el-form-item label="商品背景色" class="formsItem">
                <template>
                  <bs-color-picker v-model="curSelData.spProBgColor" style="float:left;" />
                  <el-button type="primary" class="btnClear" @click="clearColor('spProBgColor')">清除</el-button>
                </template>
              </el-form-item>

              <el-form-item label="背景图片">
                <el-col :span="18">
                  <el-input v-model="curSelData.spBgUrl" placeholder="请输入图片地址">
                    <template slot="append"><span style="cursor: pointer" @click="selImg('CosmeticTag','spBgUrl')">选择图片</span></template>
                  </el-input>
                </el-col>
                <el-col :span="18">
                  <img :src="curSelData.spBgUrl" alt="" class="imgClass">
                </el-col>
              </el-form-item>

              <el-form-item label="商品名称">
                  <template>
                    <el-radio v-model="curSelData.spGoodsNameVisible" :label="true">显示</el-radio>
                    <el-radio v-model="curSelData.spGoodsNameVisible" :label="false">不显示</el-radio>
                </template>
              </el-form-item>

              <el-form-item label="名称颜色">
                  <template>
                    <bs-color-picker v-model="curSelData.spGoodsNameColor" style="float:left;" />
                    <el-button type="primary" class="btnClear" @click="clearColor('spGoodsNameColor')">清除</el-button>
                </template>
              </el-form-item>

              <el-form-item label="商品价格">
                  <template>
                    <el-radio v-model="curSelData.spPriceVisible" :label="true">显示</el-radio>
                    <el-radio v-model="curSelData.spPriceVisible" :label="false">不显示</el-radio>
                  </template>
              </el-form-item>

              <el-form-item label="价格颜色">
                  <template>
                    <bs-color-picker v-model="curSelData.spPriceColor" style="float:left;" />
                    <el-button type="primary" class="btnClear" @click="clearColor('spPriceColor')">清除</el-button>
                  </template>
              </el-form-item>

              <el-form-item label="购买按钮">
                  <template>
                    <el-radio v-model="curSelData.spBuyButtonStyle" :label="0">不显示</el-radio>
                    <el-radio v-model="curSelData.spBuyButtonStyle" :label="1">样式一</el-radio>
                    <el-radio v-model="curSelData.spBuyButtonStyle" :label="2">样式二</el-radio>
                    <el-radio v-model="curSelData.spBuyButtonStyle" :label="3">样式三</el-radio>
                  </template>
              </el-form-item>

              <el-form-item label="按钮颜色">
                  <template>
                    <bs-color-picker v-model="curSelData.spBuyButtonColor" style="float:left;" />
                    <el-button type="primary" class="btnClear" @click="clearColor('spBuyButtonColor')">清除</el-button>
                  </template>
              </el-form-item>

              <el-form-item label="商品图标">
                <template>
                  <el-radio v-model="curSelData.spTopIconStyleType" :label="0">不显示</el-radio>
                  <el-radio v-model="curSelData.spTopIconStyleType" :label="1">系统图标</el-radio>
                </template>
              </el-form-item>

              <el-form-item label="图标样式" v-if="curSelData.spTopIconStyleType === 1">
                  <template >
                    <el-radio v-model="curSelData.spTopIconStyle" :label="1">样式一</el-radio>
                    <el-radio v-model="curSelData.spTopIconStyle" :label="2">样式二</el-radio>
                    <el-radio v-model="curSelData.spTopIconStyle" :label="3">样式三</el-radio>
                  </template>
              </el-form-item>

              <el-form-item label="图标属性" v-if="curSelData.spTopIconStyleType === 1">
                  <template>
                    <el-radio v-model="curSelData.spTopIconTxt" label="推荐">推荐</el-radio>
                    <el-radio v-model="curSelData.spTopIconTxt" label="新上">新上</el-radio>
                    <el-radio v-model="curSelData.spTopIconTxt" label="包邮">包邮</el-radio>
                  </template>
              </el-form-item>
              
              <!---->
              <el-card v-for="(item,index) in curSelData.productList" :key="item.name" class="box-card" style="margin-top: 10px">
                <div slot="header" class="clearfix">
                  <el-button style="float: right; padding: 3px 0" type="text" @click="delSpItem(index)">删除</el-button>
                </div>
                <el-row>
                  <el-col :span="6" style="position:relative;">
                    <el-image :src="item.goodPhoto" style="display: block;height: 74px; width: 80%;">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline" />
                      </div>
                    </el-image>
                    <div class="selProductButton" @click="selProduct(index)">选择商品</div>
                  </el-col>
                  <el-col :span="18">
                    <el-input v-model="item.goodsName" placeholder="这里是商品标题" readonly>
                      <template slot="append"><span style="cursor: pointer">名称</span></template>
                    </el-input>
                    <el-input v-model="item.price" placeholder="0" style="margin-top: 10px" readonly>
                      <template slot="append">价格</template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-card>
              <el-button style="margin:20px auto;width: 80%;display: block" @click="addSpItem">添加</el-button>
            </el-form>
          </div>
          <!--商品组结束-->

        <!-- <div class="pageTit">宣传营销</div> -->
          <!-- <el-form-item label="上边距">
                <template>
                  <bs-slider v-model="curSelData.yxPaddTop" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="下边距">
                <template>
                  <bs-slider v-model="curSelData.yxPaddBottom" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="左边距">
                <template>
                  <bs-slider v-model="curSelData.yxPaddLeft" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="右边距">
                <template>
                  <bs-slider v-model="curSelData.yxPaddRight" :min="0" :max="100" />
                </template>
              </el-form-item> -->
            


          <!---商城+咨询--->
           <el-form-item label="咨询背景色" class="formsItem">
              <bs-color-picker v-model="curSelData.lfBtnBgColor" style="float: left" />
              <el-button type="primary" class="btnClear" @click="clearColor('lfBtnBgColor')">清除</el-button>
            </el-form-item>
            <el-form-item label="咨询文字颜色" class="formsItem">
              <bs-color-picker v-model="curSelData.lfTextColor" style="float: left" />
              <el-button type="primary" class="btnClear" @click="clearColor('lfTextColor')">清除</el-button>
            </el-form-item>

            <el-form-item label="左边文字">
              <el-input v-model="curSelData.lfBtnText" placeholder="请输入左边按钮文字" style="margin-top: 10px">
              </el-input>
            </el-form-item>
            <el-form-item label="右边文字">
              <el-input v-model="curSelData.rtBtnText" placeholder="请输入右边按钮文字" style="margin-top: 10px">
              </el-input>
            </el-form-item>
            <el-form-item label="商城背景色" class="formsItem">
              <bs-color-picker v-model="curSelData.rtBtnBgColor" style="float: left" />
              <el-button type="primary" class="btnClear" @click="clearColor('rtBtnBgColor')">清除</el-button>
            </el-form-item>
            <el-form-item label="商城文字颜色" class="formsItem">
              <bs-color-picker v-model="curSelData.rtTextColor" style="float: left" />
              <el-button type="primary" class="btnClear" @click="clearColor('rtTextColor')">清除</el-button>
            </el-form-item>
            <el-form-item v-if="curSelData.showZx == 1" label="设置咨询字段">
              <el-input v-model="curSelData.zx_key" placeholder="请输入字段名" style="margin-top: 10px">
              </el-input>
            </el-form-item>
            <el-form-item v-if="curSelData.showZx == 1" label="指定客服">
              <el-row>
                <el-col :span="24">
                  <el-input v-model="curSelData.zx_name" placeholder="指定客服">
                    <template slot="append"><span style="cursor: pointer" @click="selKf">指定客服</span></template>
                  </el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="是否显示咨询">
              <el-radio-group v-model="curSelData.showZx">
                  <el-radio :label="1">显示</el-radio>
                  <el-radio :label="2">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>

        </div>
        <!---防伪营销编辑结束-->


        <!---防伪查询编辑开始-->
        <div style="margin-top: 10px" v-if="curSelData.btnList && curSelData.btnList[1].type">
          <div class="pageTit">防伪查询编辑</div>
          <div class="rBox">
            <el-form label-width="90px">
              <el-form-item label="背景颜色" class="formsItem">
                <template>
                  <bs-color-picker v-model="curSelData.bgColor" style="float:left;" />
                  <el-button type="primary" class="btnClear" @click="clearColor('bgColor')">清除</el-button>
                </template>
              </el-form-item>
              <el-form-item label="按钮背景色" class="formsItem">
                <template>
                  <bs-color-picker v-model="curSelData.btnBgColor" style="float:left;" />
                  <el-button type="primary" class="btnClear" @click="clearColor('btnBgColor')">清除</el-button>
                </template>
              </el-form-item>
            
              <el-form-item label="防伪背景图片">
                  <el-input v-model="curSelData.boxBg" placeholder="请输入图片地址">
                    <template slot="append"><span style="cursor: pointer" @click="selImg('CosmeticTag','boxBg')">选择图片</span></template>
                  </el-input>
                <el-col :span="18">
                  <img :src="curSelData.boxBg" alt="" class="imgClass">
                </el-col>
              </el-form-item>
              <el-form-item label="上边距">
                <template>
                  <bs-slider v-model="curSelData.paddTop" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="下边距">
                <template>
                  <bs-slider v-model="curSelData.paddBottom" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="左边距">
                <template>
                  <bs-slider v-model="curSelData.paddLeft" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="右边距">
                <template>
                  <bs-slider v-model="curSelData.paddRight" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="标题文字大小">
                <template>
                  <bs-slider v-model="curSelData.titleSize" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="标题文字颜色" class="formsItem">
                <template>
                  <bs-color-picker v-model="curSelData.titleColor" style="float:left;" />
                  <el-button type="primary" class="btnClear" @click="clearColor('titleColor')">清除</el-button>
                </template>
              </el-form-item>
              <el-form-item label="副标题文字大小">
                <template>
                  <bs-slider v-model="curSelData.SubheadingSize" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="副标题文字颜色" class="formsItem">
                <template>
                  <bs-color-picker v-model="curSelData.SubheadingColor" style="float:left;" />
                  <el-button type="primary" class="btnClear" @click="clearColor('SubheadingColor')">清除</el-button>
                </template>
              </el-form-item>
              <el-form-item label="二维码大小">
                <template>
                  <bs-slider v-model="curSelData.scanSize" :min="50" :max="150" />
                </template>
              </el-form-item>
              <el-form-item label="二维码上边距">
                <template>
                  <bs-slider v-model="curSelData.scanTop" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="二维码下边距">
                <template>
                  <bs-slider v-model="curSelData.scanBottom" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="二维左边距">
                <template>
                  <bs-slider v-model="curSelData.scanLeft" :min="0" :max="100" />
                </template>
              </el-form-item>
              <el-form-item label="二维码背景">
                    <el-input v-model="curSelData.scanBg" placeholder="请输入图片地址">
                    <template slot="append"><span style="cursor: pointer" @click="selImg('CosmeticTag','scanBg')">选择图片</span></template>
                  </el-input>
              </el-form-item>
              
            <el-form-item label="提示信息文字大小">
              <template>
                <bs-slider v-model="curSelData.myBoxFize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="提示信息文字颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.myBoxColor" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('myBoxColor')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="提示信息图片">
                    <el-input v-model="curSelData.myBoxTipImg" placeholder="请输入图片地址">
                    <template slot="append"><span style="cursor: pointer" @click="selImg('CosmeticTag','myBoxTipImg')">选择图片</span></template>
                  </el-input>
            </el-form-item>
            <el-form-item label="标识码标题大小">
              <template>
                <bs-slider v-model="curSelData.codeTitleFize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="标识码标题颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.codeTitleColor" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('codeTitleColor')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="标识码文字大小">
              <template>
                <bs-slider v-model="curSelData.codeContentFize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="标识码颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.codeContentColor" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('codeContentColor')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="签发信息文字大小">
              <template>
                <bs-slider v-model="curSelData.msgBox3Fize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="签发信息颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.msgBox3Color" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('msgBox3Color')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="查询信息文字大小">
              <template>
                <bs-slider v-model="curSelData.msgBox4Fize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="查询信息文字颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.msgBox4Color" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('msgBox4Color')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="时间地点文字大小">
              <template>
                <bs-slider v-model="curSelData.msgBox5Fize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="时间地点文字颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.msgBox5Color" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('msgBox5Color')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="查询次数文字大小">
              <template>
                <bs-slider v-model="curSelData.msgBox6Fize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="查询次数文字颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.msgBox6Color" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('msgBox6Color')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="扫码次数大小">
              <template>
                <bs-slider v-model="curSelData.msgBox7Fize" :min="0" :max="100" />
              </template>
            </el-form-item>
            <el-form-item label="扫码次数颜色" class="formsItem">
              <template>
                <bs-color-picker v-model="curSelData.msgBox7Color" style="float:left;" />
                <el-button type="primary" class="btnClear" @click="clearColor('msgBox7Color')">清除</el-button>
              </template>
            </el-form-item>
            <el-form-item label="排序图片">
                <template>
                  <el-radio v-model="curSelData.myboxWrapImg" :label="1">显示</el-radio>
                  <el-radio v-model="curSelData.myboxWrapImg" :label="2">不显示</el-radio>
                </template>
            </el-form-item>
            <el-form-item label="标识码">
                  <template>
                    <el-radio v-model="curSelData.showVerCode" :label="1">不显示</el-radio>
                    <el-radio v-model="curSelData.showVerCode" :label="2">显示</el-radio>
                  </template>
              </el-form-item>
              <el-form-item label="跳转控件">
                  <template>
                    <el-radio v-model="curSelData.jumpStyle" :label="1">不显示</el-radio>
                    <el-radio v-model="curSelData.jumpStyle" :label="2">风格一</el-radio>
                  </template>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!---防伪查询编辑结束-->
        
      
    </el-form>
  </div>
</template>
<style scoped>
.btn-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.btn-item:hover {
  background-color: #f5f7fa;
}

.btn-item:last-child {
  border-bottom: none;
}

.btn-text {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  flex: 1;
}

.btn-radio-group {
  display: flex;
  align-items: center;
}

.btn-radio {
  margin-right: 16px !important;
  font-size: 14px;
}

.btn-radio:last-child {
  margin-right: 0 !important;
}

.no-btn-tip {
  padding: 20px;
  text-align: center;
  color: #909399;
  font-size: 14px;
  background-color: #fafafa;
  border-radius: 4px;
}

/* 美化卡片样式 */
.box-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #ebeef5;
  overflow: hidden;
}

.box-card:hover {
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15) !important;
}
.imgClass {
  margin-top: 10px;
  max-height: 100px;
}
.pageTit{
  font-size: 16px;
  font-weight: 600;
  color: #1C71E3;
  padding: 12px 20px;
  background-color: #EEF2F8;
  border-left: 4px solid #1C71E3;
  margin: 20px 0 15px;
  border-radius: 0 4px 4px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.selProductButton{
    position: absolute;
    height: 20px;
    left: 0;
    right: 20%;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    color: #fff;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    position: absolute;
    cursor: pointer;
  }
</style>
<script>
import BsSlider from '../module/BsSlider'
import BsColorPicker from '../module/BsColorPicker'
export default {
  components: {
    BsSlider,
    BsColorPicker,
  },
  props: {
    curSelData: {
      type: Object,
      default: () => {
        tabbar;
      },
    },
  },
  computed: {
   
  },
  data() {
    return {};
  },
  methods: {
    // 选择图片
    selImg(type, attr, index) {
      this.$emit("selImg", type, attr, index);
    },
    addWrapItem() {
      this.curSelData.infoWrap.push({
        enTitle: '',
        chTitle: '',
        type: '1',
        list: [],
      })
    },
    delWrapItem(index) {
      this.curSelData.infoWrap.splice(index, 1);
    },
    addInfoItem(infoItemIndex, index) {
      this.curSelData.infoWrap[index].list.push({
        title: '',
        msg: '',
      })
    },
    delInfoItem(infoItemIndex, index) {
      this.curSelData.infoWrap[index].list.splice(infoItemIndex, 1);
    },

    // 营销
    addItem() {
      const width = (100 / (this.curSelData.picList.length + 1)).toFixed(2)
      this.curSelData.picList.forEach(item => {
        item.width = width + '%'
      })
      this.curSelData.picList.push({ width: width + '%', url: 'https://apkpic.86122m.com/custom/14abe8ed67758411564838a4387608d0.jpeg' })
    },
    delPic(index) {
      const width = (100 / (this.curSelData.picList.length - 1)).toFixed(2)
      this.curSelData.picList.forEach((item,index) => {
        item.width = width + '%'
      })
      this.curSelData.picList.splice(index, 1)
    },
    
    
    addVideItem() {
      this.curSelData.videoList.push({
        url: '',
        videoHeight: null,
        videoWidth: null
      })
    },
    delVideo(index) {
      this.curSelData.videoList.splice(index, 1)
    },
    selVideo(index) {
      this.$emit('selVideo', 'CosmeticTag', 'videoList', index)
    },

    clearColor(attr) {
      this.curSelData[attr] = 'transparent'
    },
    selKf() {
      this.$emit('selKf', this.curSelData.zx_key)
    },

    addItem2() {
      const width = (100 / (this.curSelData.picList2.length + 1)).toFixed(2)
      this.curSelData.picList2.forEach(item => {
        item.width = width + '%'
      })
      this.curSelData.picList2.push({ width: width + '%', url: 'https://apkpic.86122m.com/custom/14abe8ed67758411564838a4387608d0.jpeg' })
    },
    delPic2(index) {
      const width = (100 / (this.curSelData.picList2.length - 1)).toFixed(2)
      this.curSelData.picList2.forEach((item,index) => {
        item.width = width + '%'
      })
      this.curSelData.picList2.splice(index, 1)
    },
    addVideItem2() {
      this.curSelData.videoList2.push({
        url: '',
        videoHeight: null,
        videoWidth: null
      })
    },
    delVideo2(index) {
      this.curSelData.videoList2.splice(index, 1)
    },
    selVideo2(index) {
      this.$emit('selVideo', 'CosmeticTag', 'videoList2', index)
    },
    addSwipeItem() {
      this.curSelData.swipePicList.push({
        url: '',
        link: '',
      })
    },
    delSwipeItem(index) {
      this.curSelData.swipePicList.splice(index, 1)
    },

    // 商品组
    clearTit() {
      this.curSelData.spTitle = ''
    },
    clearSubTit() {
      this.curSelData.spSubTitle = ''
    },
    selProduct(index) {
      this.$emit('selProduct', index)
    },
    addSpItem(){
      let str='商品名称' + (this.curSelData.productList.length ? this.curSelData.productList.length + 1 : '1')
      this.curSelData.productList.push(
        {
          goodsName: str,
          price: '',
          goodPhoto: 'https://apkpic.86122m.com/yimai_photos/goods-2.jpeg',
        },
      )
    },
    delSpItem(index){
      this.curSelData.productList.splice(index, 1)
      //  this.curSelData.productList.map((item, index) => {
      //    item.goodsName = '商品名称' + (index+1)
      //  })
    },

  }
}
</script>